'use strict';

module.exports = /* @ngInject */ function () {

	const ACL_ROLE_TYPES = {
		ADMIN: 'LOGIN_ADMIN',
		CUSTOMER: 'LOGIN_CUSTOMER',
		SUPPLIER: 'LOGIN_SUPPLIER'

	};

	let userType; // one of ['ADMIN', 'CUSTOMER', 'SUPPLIER']
	let roleType;
	let userLogin;
	let companyLogin;

	let aclCache = new Map();

	this.setAclUserInformation = (user, companyLoginName) => {
		userType = user.type;
		userLogin = user.login;
		roleType = ACL_ROLE_TYPES[userType];
		if (companyLoginName) {
			companyLogin = companyLoginName;
		}
	};

	this.$get = /* @ngInject */ function ($resource, $http, apiConfig) {

		/**
		 * Get permission of a given resource and its action from Eproc-Api
		 * @returns {*}
		 */
		function getAclPermissionFromApi(){
			return $resource(
				apiConfig.$get().apiUrl + `/acl` +
				`?resource=:resource&action=:action`,
				{
					resource: '@resource',
					action: '@action'
				},
				{
					query: {
						method: 'GET',
						isArray: true
					}
				}
			);
		}

		/**
		 * Receive the permission of a resource and the required action by either chache (if it was checked already)
		 * or by an API call
		 * @param resource
		 * @param action
		 * @returns {Promise<
		 * {
		 * 		request: {resource: string, action: string, strict: boolean},
		 * 		allow: boolean,
		 * 		message: string
		 * }>}
		 */
		function getAcl(resource, action){
			return new Promise(((resolve, reject) => {
				const cachedPermission = aclCache.get(resource + action);
				if(cachedPermission){
					resolve(cachedPermission);
				} else {
					getAclPermissionFromApi().query({resource, action}).$promise.then((response) => {
						const permission = response[0];
						aclCache.set(resource + action, permission);
						resolve(permission);
					}, (error) => {
						console.error(error);
						reject();
					})
				}
			}))
		}

		return {
			getPermission: getAcl,
			test: $resource(
				apiConfig.$get().apiUrl + `/acl` +
				`?resource=:resource&action=:action`,
				{
					resource: '@resource',
					action: '@action'
				},
				{
					query: {
						method: 'GET',
						isArray: true
					}
				}
			)
		}
	};

}
